import { render, staticRenderFns } from "./Linkus.vue?vue&type=template&id=cb690190"
import script from "./Linkus.vue?vue&type=script&lang=js"
export * from "./Linkus.vue?vue&type=script&lang=js"
import style0 from "./Linkus.vue?vue&type=style&index=0&id=cb690190&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_23r6mjrsgsxizcadxwhph2x2by/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports